import React, { useEffect, useRef } from "react";
import { useDataFormContext } from "@/context/FormDataContext";
import { Button, Grid2 } from "@mui/material";
import { Wrapper } from "./styles";

/**
 * @returns InvalidData component
 */
export default function InvalidData(): React.JSX.Element {
  const {
    dataForm,
    currentAdm,
    setDataForm,
    setCurrentFormStep,
    setCurrentFormVariation,
  } = useDataFormContext();

  /**
   * resetPartialData
   * @return {void}
   */
  function resetPartialData(): void {
    setDataForm({
      ...dataForm,
      ...{
        registrationId: undefined,
      },
    });

    setCurrentFormStep(0);
    setCurrentFormVariation("all");
  }

  const inputRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (inputRef.current) {
      const height = inputRef?.current?.offsetHeight;
      window.parent.postMessage(
        ["setHeight", `${height + (height * 85) / 100}`],
        "*"
      );
    }
  }, []);

  return (
    <div ref={inputRef}>
      <Wrapper>
        <h2>Dados Inválidos!</h2>
        <p>
          <span>
            Não conseguimos validar seus dados junto à {currentAdm.name}
          </span>
        </p>
        <p>Por favor confira as informações inseridas e tente novamente.</p>
      </Wrapper>

      <Grid2 container spacing={3} justifyContent={"center"}>
        <Grid2 size={{ xs: 12, sm: 5 }}>
          <Button fullWidth variant="goFoward" onClick={resetPartialData}>
            Revisar dados
          </Button>
        </Grid2>
      </Grid2>
    </div>
  );
}
